import { createStore, applyMiddleware } from 'redux';
import axiosMiddleware from 'redux-axios-middleware';
import axios from 'axios';
import reducers, { whitelistReducers } from './reducers';
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import ErrorManager from './ErrorManager';

const persistConfig = {
  key: "root",
  storage,
  whitelist: whitelistReducers,
};

const client = axios.create({ // all axios can be used, shown in axios documentation
  baseURL: process.env.REACT_APP_API_URL,
  responseType: 'json',
  // withCredentials: true,
});

const middlewareConfig = {
  interceptors: {
    request: [
      {
        success: async function ({ getState, dispatch, getSourceAction }, req) {
          const token = sessionStorage.getItem("token");

          if (token) {
            req.headers["Authorization"] = `Bearer ${token}`;
          }

          return req;
        },
        error: function ({ getState, dispatch, getSourceAction }, error) {
          return Promise.reject(error);
        },
      },
    ],

    response: [
      {
        success: function ({ getState, dispatch, getSourceAction }, res) {
          return Promise.resolve(res);
        },

        error: function ({ getState, dispatch, getSourceAction }, error) {

          const message =
            error?.response?.data?.error ||
            error?.response?.data?.message;

          // Logout user if session is invalidated
          if (
            message === "Logged in from another device" ||
            message === "Session expired" ||
            message === "Invalid session"
          ) {

            sessionStorage.clear();
            localStorage.removeItem("isAuthenticated");
            localStorage.removeItem("privillage");
            localStorage.removeItem("userName");
            localStorage.removeItem("userType");
            localStorage.removeItem("userId");

            window.location.href = "/";
          }

          ErrorManager.handle(error);

          return Promise.reject(error);
        },
      },
    ],
  },
};



const pReducer = persistReducer(persistConfig, reducers);
const store = createStore(
  pReducer,
  applyMiddleware(axiosMiddleware(client, middlewareConfig))
);
const persistor = persistStore(store);

export { persistor, store };
